import { DashboardPage } from "@/components/dashboard";

export const Main = DashboardPage;
